<template>
  <div class="info-chart-2">
    <div class="left">
      <div class="btn-dw">
        <Download
          :dButtonsDownloads="dButtonsDownloads"
          :excel_info="excel_info1"
          echartRefName="chart_2t1" />
      </div>
      <el-table
        :key="checked ? 't1' : 't2'"
        class="table1"
        :header-cell-style="tableStyle"
        :data="list"
        height="calc(100% - 50px)"
        style="width: 100%">
        <el-table-column type="index" width="80" label="序号" />
        <el-table-column
          align="center"
          prop="机构名称"
          label="机构名称"
          min-width="200"
          v-if="!checked" />
        <el-table-column align="center" prop="配售对象类型" label="配售对象类型" min-width="94" />
        <el-table-column
          align="center"
          prop="拟认购数量（万份）"
          label="拟认购数量（万份）"
          min-width="80" />
        <el-table-column align="center" prop="拟认购价格" label="拟认购价格" min-width="80">
          <template slot-scope="scope">
            <span>{{ scope.row['拟认购价格'].toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="备注" label="备注" min-width="80" v-if="!checked" />
      </el-table>
    </div>
    <div class="right" ref="chart_2t1">
      <div ref="chart1Ref" style="height: 50%"></div>
      <div class="iconfont icon-fangda fd1" @click="showChartDialog(1)"></div>
      <div class="iconfont icon-fangda fd2" @click="showChartDialog(2)"></div>
      <div style="position: relative; height: 50%">
        <div style="position: absolute; left: 0; top: 40px; color: var(--chart_title)">
          <el-checkbox v-model="checked" @change="loadData" />&nbsp;&nbsp;是否根据类别聚合
        </div>
        <div ref="chart2Ref" style="height: calc(100% - 20px)"></div>
      </div>
    </div>
    <ChartDialog :show.sync="show_chart_dialog" :echart_options="chart_options" />
  </div>
</template>

<script>
import ChartDialog from '../../components/Basic/ChartDialog.vue';
import Download from '@/components/Basic/Download.vue';
import { fnReturnTableStyle } from '@/utils/util';
import ecStat from 'echarts-stat';
echarts.registerTransform(ecStat.transform.histogram);

export default {
  name: 'info-chart-2',
  components: { ChartDialog, Download },
  props: {
    code: String,
  },
  data() {
    return {
      checked: false,
      list: [],
      ipo_price: '',
      ROOTFONTFIZE: '',
      chart_options: {},
      chart_options_1: {},
      chart_options_2: {},
      show_chart_dialog: false,
      excel_info1: Object.freeze({
        overviewName: '投资者报价',
        excel_data: [],
        json_fields: {},
      }),
      dButtonsDownloads: Object.freeze([
        {
          id: '241020',
          name: '下载表格',
        },
        {
          id: '241020',
          name: '下载图片',
        },
      ]),
    };
  },
  computed: {
    tableStyle() {
      const val = this.$store.state.theme === 'dark';
      return () => fnReturnTableStyle(val);
    },
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
  },
  watch: {
    /*  currentTheme(newVal, oldVal) {
       setTimeout(() => {
        this.chart1();
        this.chart2();
      }, 0);
    }, */
  },
  mounted() {
    this.loadData();
    this.resize();
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
    this.echart1_instance && this.echart1_instance.dispose();
    this.echart2_instance && this.echart2_instance.dispose();
    this.echart1_instance = null;
    this.echart2_instance = null;
  },
  methods: {
    showChartDialog(index) {
      if (index === 1) {
        this.chart_options = Object.freeze(this.chart_options_1);
      } else {
        this.chart_options = Object.freeze(this.chart_options_2);
      }
      this.show_chart_dialog = true;
    },
    resize() {
      this.fnGetWidth();
      this.echart1_instance && this.echart1_instance.resize();
      this.echart2_instance && this.echart2_instance.resize();
    },
    fnGetWidth() {
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1400 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      this.ROOTFONTFIZE = ROOTFONTFIZE / 10;
      return;
    },
    async loadData() {
      const groupby = this.checked ? 1 : 0;
      const code = this.code;
      const { data } = await this.$https.get(
        `/api/v2_5/investor_quotation?groupby=${groupby}&code=${code}`
      );
      if (data.code !== 200){
        if(data.msg==='0'){
          return this.$message.error("暂无数据");
        }
        return this.$message.error(data.msg);
      }
      const { result, ipo_price } = data.data;
      this.list = Object.freeze(result);
      this.ipo_price = ipo_price;
      if (!this.list.length) return;
      setTimeout(() => {
        const json_fields = {
          机构名称: '机构名称',
          配售对象类型: '配售对象类型',
          '拟认购数量（万份）': '拟认购数量（万份）',
          拟认购价格: '拟认购价格',
          备注: '备注',
        };
        if (this.checked) {
          delete json_fields['机构名称'];
          delete json_fields['备注'];
        }
        this.excel_info1 = Object.freeze({
          overviewName: '投资者报价',
          excel_data: this.list,
          json_fields,
        });
        this.chart1();
        this.chart2();
      }, 0);
    },
    chart1() {
      if (!this.echart1_instance) {
        this.echart1_instance = this.$echarts.init(this.$refs.chart1Ref);
      }
      this.echart1_instance.clear();
      const source = this.list.map((item) => item['拟认购价格']);
      const bins = ecStat.histogram(source, 'sturges');

      const index = bins.bins.findIndex(({ x1 }) => x1 >= this.ipo_price) || 0;
      const max = Math.max(...source);

      let OPTIONDATA =
        this.$store.state.theme == 'dark'
          ? this.$store.state.OPTIONDATA
          : this.$store.state.OPTIONDATA_light;

      const options = {
        series: [
          {
            name: '拟认购价格',
            type: 'bar',
            label: {
              show: false,
              position: 'top',
              color: '#fff',
              fontSize: this.ROOTFONTFIZE * (14 / 144),
            },
            itemStyle: {
              color: ({ dataIndex }) => {
                return dataIndex >= index ? '#00edef' : '#d9d9d9';
              },
            },
            encode: {
              x: 4,
              y: 1,
            },
            data: bins.data,
            markLine: {
              symbol: ['none', 'none'],
              data: [
                {
                  xAxis: index,
                },
              ],
              lineStyle: {
                type: 'solid',
                color: '#fb661c',
                width: 2,
              },
              label: {
                show: true,
                color: '#fb661c',
                fontSize: this.ROOTFONTFIZE * (14 / 144),
                formatter: () => {
                  return this.ipo_price;
                },
              },
            },
          },
        ],
        title: [
          {
            text: '报价范围情况',
            textStyle: {
              color: OPTIONDATA.title.textStyle.color,
              fontSize: this.ROOTFONTFIZE * (16 / 144),
            },
            top: this.ROOTFONTFIZE * (15 / 144),
            left: 'center',
          },
          {
            text: `${max}\n最高价`,
            textStyle: {
              color: OPTIONDATA.title.textStyle.color,
              fontSize: this.ROOTFONTFIZE * (12 / 144),
            },
            bottom: this.ROOTFONTFIZE * (0 / 144),
            left: this.ROOTFONTFIZE * (20 / 144),
          },
        ],
        tooltip: {
          formatter: ({ name, data, marker, componentType }) => {
            if (componentType === 'markLine') return `认购价格：${this.ipo_price}`;
            const [o, t] = name.split(' - ');
            const _name = `${Number(o).toFixed(1)}-${Number(t).toFixed(1)}`;
            return `${marker}${_name}：${data[1]}`;
          },
        },
        xAxis: {
          type: 'category',
          scale: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#dcdcdd',
            },
            onZero: false, //轴线是否在0刻度轴上
            // onZero: true, //轴线是否在0刻度轴上
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            fontSize: this.ROOTFONTFIZE * (14 / 144),
            show: true,
            showMaxLabel: true,
            color: OPTIONDATA.xAxis.axisLabel.color,
            formatter: (v) => {
              const [o, t] = v.split(' - ');
              return `${Number(o).toFixed(1)}-${Number(t).toFixed(1)}`;
            },
          },
        },
        yAxis: [
          {
            type: 'value',
            axisLine: {
              show: false,
              lineStyle: {
                color: '#dcdcdd',
              },
            },
            axisTick: {
              show: false,
              //x轴刻度相关设置
              alignWithLabel: true,
            },
            axisLabel: {
              fontSize: this.ROOTFONTFIZE * (14 / 144),
              show: true,
              color: OPTIONDATA.yAxis.axisLabel.color,
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: OPTIONDATA.splitLine.lineStyle.color,
              },
            },
          },
        ],
        grid: {
          top: this.ROOTFONTFIZE * (80 / 144),
          bottom: this.ROOTFONTFIZE * (30 / 144),
          left: this.ROOTFONTFIZE * (20 / 144),
          right: this.ROOTFONTFIZE * (40 / 144),
          containLabel: true,
        },
        toolbox: {
          // 工具箱按钮
          right: 0,
          top: -5,
          itemSize: 18,
          iconStyle: {
            borderColor: OPTIONDATA.toolbox.iconStyle.borderColor,
          },
          feature: {
            dataZoom: {}, // 区域缩放
          },
        },
      };
      this.chart_options_1 = Object.freeze(options);
      this.echart1_instance.setOption(options);
      this.echart1_instance.resize();
    },
    chart2() {
      if (!this.echart2_instance) {
        this.echart2_instance = this.$echarts.init(this.$refs.chart2Ref);
      }
      this.echart2_instance.clear();

      let OPTIONDATA =
        this.$store.state.theme == 'dark'
          ? this.$store.state.OPTIONDATA
          : this.$store.state.OPTIONDATA_light;

      const data = this.list.map((item) => {
        return [
          item['拟认购数量（万份）'],
          item['拟认购价格'],
          item['备注'],
          item['配售对象类型'],
          item['机构名称'],
        ];
      });
      const data_v = this.list.map((item) => {
        return item['拟认购数量（万份）'];
      });

      const max = Math.max(...data_v);
      const min = Math.min(...data_v);
      const checked = this.checked;

      const options = {
        series: [
          {
            name: '',
            data,
            type: 'scatter',
            symbolSize: this.ROOTFONTFIZE * (13 / 144),
            cursor: 'pointer',
            itemStyle: {
              color: (item) => {
                const v = item.value[2];
                if (!v) {
                  return 'rgba(90, 202, 198, 0.8)';
                }
                return v === '有效报价' ? 'rgba(90, 202, 198, 0.8)' : 'rgba(217, 217, 217, 0.8)';
              },
            },
            markLine: {
              symbol: ['none', 'none'],
              data: [
                {
                  yAxis: this.ipo_price,
                },
              ],
              lineStyle: {
                type: 'solid',
                color: '#fb661c',
                width: 2,
              },
              label: {
                show: true,
                color: '#fb661c',
                fontSize: this.ROOTFONTFIZE * (14 / 144),
                formatter: function (val) {
                  return val.value;
                },
              },
            },
          },
        ],
        visualMap: {
          show: false,
          min, // x轴数据的最小值，根据你的实际数据调整
          max, // x轴数据的最大值，根据你的实际数据调整
          dimension: 0, // 对应 x 轴数据
          inRange: {
            symbolSize: checked ? [8, 24] : [4, 12], // 散点大小限制在 1 到 10 之间
          },
        },
        title: [
          {
            text: '报价散点分布',
            textStyle: {
              color: OPTIONDATA.title.textStyle.color,
              fontSize: this.ROOTFONTFIZE * (16 / 144),
            },
            top: this.ROOTFONTFIZE * (15 / 144),
            left: 'center',
          },
          {
            text: '申\n报\n价\n格',
            textStyle: {
              color: OPTIONDATA.title.textStyle.color,
              fontSize: this.ROOTFONTFIZE * (12 / 144),
            },
            top: this.ROOTFONTFIZE * (80 / 144),
            left: this.ROOTFONTFIZE * (10 / 144),
          },
          {
            text: '拟认购数量（万份）',
            textStyle: {
              color: OPTIONDATA.title.textStyle.color,
              fontSize: this.ROOTFONTFIZE * (12 / 144),
            },
            bottom: 0,
            right: 0,
          },
        ],
        tooltip: {
          appendTo: 'body',
          extraCssText: 'max-width:400px;white-space:unset',
          formatter: ({ data, marker, componentType }) => {
            if (componentType === 'markLine') return `认购价格：${this.ipo_price}`;
            const [v1, v2, v3, v4, v5] = data;
            if (v3) {
              return `${v3}<br/>${v4}<br/>${v5}<br/>${marker}拟认购数量：${v1}<br/>${marker}拟认购价格：${v2.toFixed(
                2
              )}`;
            } else {
              return `${v4}<br/>${marker}拟认购数量：${v1}<br/>${marker}拟认购价格：${v2.toFixed(
                2
              )}`;
            }
          },
        },
        xAxis: {
          type: 'value',
          scale: true,
          splitNumber: 3,
          axisLine: {
            show: false,
            lineStyle: {
              color: '#dcdcdd',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            fontSize: this.ROOTFONTFIZE * (14 / 144),
            show: true,
            showMaxLabel: true,
            color: OPTIONDATA.xAxis.axisLabel.color,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: OPTIONDATA.splitLine.lineStyle.color,
            },
          },
        },
        yAxis: {
          type: 'value',
          scale: true,
          axisLine: {
            show: false,
            lineStyle: {
              color: '#dcdcdd',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: this.ROOTFONTFIZE * (14 / 144),
            show: true,
            formatter: (val) => {
              return Number(val).toFixed(1);
            },
            color: OPTIONDATA.yAxis.axisLabel.color,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: OPTIONDATA.splitLine.lineStyle.color,
            },
          },
        },
        grid: {
          top: this.ROOTFONTFIZE * (80 / 144),
          bottom: this.ROOTFONTFIZE * (30 / 144),
          left: this.ROOTFONTFIZE * (35 / 144),
          right: this.ROOTFONTFIZE * (40 / 144),
          containLabel: true,
        },
        toolbox: {
          // 工具箱按钮
          right: 0,
          top: -5,
          itemSize: 18,
          iconStyle: {
            borderColor: OPTIONDATA.toolbox.iconStyle.borderColor,
          },
          feature: {
            dataZoom: {}, // 区域缩放
          },
        },
      };
      this.chart_options_2 = Object.freeze(options);
      this.echart2_instance.setOption(options);
      this.echart2_instance.resize();
    },
  },
};
</script>

<style scoped lang="less">
.info-chart-2 {
  display: flex;
  height: calc(var(--ROOTFONTFIZE) * (600 / 144));
  .left {
    width: 55%;
    .btn-dw {
      display: flex;
      justify-content: flex-end;
      height: 50px;
    }
  }
  .right {
    position: relative;
    width: 45%;
    box-sizing: border-box;
    padding-left: 20px;
    .fd1 {
      right: calc(var(--ROOTFONTFIZE) * (65 / 144));
      top: calc(var(--ROOTFONTFIZE) * (2 / 144));
    }
    .fd2 {
      right: calc(var(--ROOTFONTFIZE) * (65 / 144));
      top: calc(var(--ROOTFONTFIZE) * (302 / 144));
    }
  }
}
</style>
